import { render, staticRenderFns } from "./BankIconSVG.vue?vue&type=template&id=2b5eebc1&"
import script from "./BankIconSVG.vue?vue&type=script&lang=js&"
export * from "./BankIconSVG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports